export default "__VITE_ASSET__70a23c9d__"